"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportPortalAnnualHomePaymentChoiceWidget = void 0;
var React = require("react");
require("react-datepicker/src/stylesheets/datepicker.scss");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var SupportPortalAnnualHomePaymentChoiceWidget = /** @class */ (function (_super) {
    __extends(SupportPortalAnnualHomePaymentChoiceWidget, _super);
    function SupportPortalAnnualHomePaymentChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            if (event.target.value === "fullPrice") {
                journey_services_1.ObjectManipulator.setField("uistate.payFullPrice", _this.props.interaction, true);
                _this.setState({ payFullPrice: true });
            }
            else if (event.target.value === "partOfPrice") {
                journey_services_1.ObjectManipulator.setField("uistate.payFullPrice", _this.props.interaction, false);
                _this.setState({ payFullPrice: false });
            }
        };
        _this.state = {
            payFullPrice: undefined,
        };
        return _this;
    }
    SupportPortalAnnualHomePaymentChoiceWidget.prototype.render = function () {
        var additionalPremium = this.props.interaction.factors.additionalPremium;
        return (React.createElement("div", null,
            this.getPaymentText(),
            this.getPaymentButtons(additionalPremium)));
    };
    SupportPortalAnnualHomePaymentChoiceWidget.prototype.getPaymentText = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("h1", { className: "text-blue-2" }, "How'd you like to pay?")));
    };
    SupportPortalAnnualHomePaymentChoiceWidget.prototype.getPaymentButtons = function (additionalPremium) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "w-100" },
                React.createElement("div", { className: "d-flex payment-choice text-center" },
                    React.createElement("div", { className: "custom-control custom-radio w-50 mx-0 pr-2" },
                        React.createElement("input", { id: "yearly", className: "custom-control-input", type: "radio", name: "payment", value: "fullPrice", onChange: this.handleOnChangeEvent }),
                        React.createElement("label", { className: "custom-control-label h-100 p-2", htmlFor: "yearly" },
                            this.state.payFullPrice === true
                                ? React.createElement("img", { className: "radio-circle", alt: "full selected", src: "/img/radio-circle-selected.svg" })
                                : React.createElement("img", { className: "radio-circle", alt: "full", src: "/img/radio-circle.svg" }),
                            React.createElement("p", { className: "font-weight-semi-bold pt-3" },
                                "Pay \u00A3",
                                additionalPremium,
                                " now by card"),
                            React.createElement("div", null,
                                React.createElement("img", { className: "visa-icon-small", alt: "visa-icon", src: "/img/visa-icon.svg" }),
                                React.createElement("img", { className: "mastercard-icon-small", alt: "mastercard-icon", src: "/img/mastercard-icon.svg" })))),
                    React.createElement("div", { className: "custom-control custom-radio w-50 mx-0 pl-2" },
                        React.createElement("input", { id: "monthly", className: "custom-control-input", type: "radio", name: "payment", value: "partOfPrice", onChange: this.handleOnChangeEvent }),
                        React.createElement("label", { className: "custom-control-label h-100 p-2", htmlFor: "monthly" },
                            this.state.payFullPrice === false
                                ? React.createElement("img", { className: "radio-circle", alt: "monthly selected", src: "/img/radio-circle-selected.svg" })
                                : React.createElement("img", { className: "radio-circle", alt: "monthly", src: "/img/radio-circle.svg" }),
                            React.createElement("p", { className: "font-weight-semi-bold pt-3" }, "Continue with your direct debit payment plan")))))));
    };
    return SupportPortalAnnualHomePaymentChoiceWidget;
}(plugin_journey_1.WidgetBase));
exports.SupportPortalAnnualHomePaymentChoiceWidget = SupportPortalAnnualHomePaymentChoiceWidget;
//# sourceMappingURL=SupportPortalAnnualHomePaymentChoiceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/agentPortal/SupportPortalAnnualHomePaymentChoiceWidget.js
// module id = 3708
// module chunks = 0